export var VERSION = '2.18.1';
//# sourceMappingURL=version.js.map